import * as XLSX from 'xlsx';
import { WorkBook } from 'xlsx';
import { DEFAULT_FILE_EXPORT_LOG_NAME, DEFAULT_FILE_EXPORT_NAME, DEFAULT_FILE_EXPORT_SHEET_NAME } from '@core/utils/export.constants';
import { Injectable } from '@angular/core';


@Injectable()
export class XlsxService {
    public async createXlsxFileFromBlob(source: Blob, fileName?: string, sheetName?: string): Promise<void> {
        const wb: XLSX.WorkBook = await this.blobToWb(source);
        XLSX.utils.book_append_sheet(wb, null, sheetName || DEFAULT_FILE_EXPORT_SHEET_NAME);
        XLSX.writeFile(wb, fileName || DEFAULT_FILE_EXPORT_NAME);
    }

    public createXlsxFileFromFile(source: string, fileName?: string, sheetName?: string): void {
        const wb: XLSX.WorkBook = XLSX.read(source);
        XLSX.utils.book_append_sheet(wb, null, sheetName || DEFAULT_FILE_EXPORT_SHEET_NAME);
        XLSX.writeFile(wb, fileName || DEFAULT_FILE_EXPORT_LOG_NAME);
    }

    public exportTablesOnPageToExcelFile(tablesOnPage: HTMLCollection): void {
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(tablesOnPage[0]);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, DEFAULT_FILE_EXPORT_SHEET_NAME);
        XLSX.writeFile(wb, DEFAULT_FILE_EXPORT_NAME);
    }

    private async blobToWb(blob: Blob): Promise<WorkBook> {
        return XLSX.read(await blob.arrayBuffer());
    }
}
